<template>
    <v-card class="ma-1 mb-2">
        <v-row align="center" no-gutters class="pa-2">
            <v-col class="d-flex align-center">
                <v-icon v-if="mission.active_mission" color="red" size="10" class="mr-2">
                    mdi-circle
                </v-icon>

                <div class="d-flex flex-column  ml-2">
                    <span class="font-weight-bold text-subtitle-1 text-left">
                        {{ mission.name }}
                    </span>
                    <span class="text-caption text-error" v-if="missionDisable">
                        {{ missionDisableReason }}
                    </span>
                </div>
            </v-col>

            <v-col cols="auto" class="d-flex align-center">
                <v-btn icon="mdi-information" color="primary" @click="show_additional_info = !show_additional_info"
                    variant="plain"></v-btn>

                <v-btn icon="mdi-plus" :color="!missionDisable ? 'primary' : 'grey'" @click="emit('add', mission)"
                    :disabled="missionDisable" variant="plain"></v-btn>
            </v-col>
        </v-row>

        <v-expand-transition>
            <v-card v-show="show_additional_info" class="px-5 pb-3 text-justify" variant="text">
                {{ mission.description }}
            </v-card>
        </v-expand-transition>
    </v-card>
</template>

<script setup>
import { computed, ref } from 'vue';

const { mission } = defineProps(['mission']);
const emit = defineEmits(['add']);

const show_additional_info = ref(false);

const missionDisableReason = computed(() => {
    if (mission.vehicles.length === 0) return 'No Assigned Vehicle.';
    if (mission.no_records) return 'No route data mapped.';
    return '';
});

const missionDisable = computed(() => !!missionDisableReason.value);
</script>
